(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["img-gen-sec-home"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded" , () => {
    const copybtns = document.querySelectorAll(".igh-copy-btn");
    copybtns.forEach((btn) => {
      btn.addEventListener("click", () =>{
        const card = btn.closest(".igh-overlay-container");
        const prompt = card.querySelector(".igh-prompt").innerText;
        
        const btnText = btn.querySelector(".igh-copy-text")
        const copySvg = btn.querySelector(".igh-copy-svg")
        const copiedSvg = btn.querySelector(".igh-copied-svg")
        navigator.clipboard.writeText(prompt).catch(() => {
            const ta = document.createElement('textarea');
            ta.value = prompt;
            ta.style.position = 'fixed';
            ta.style.opacity = '0';
            document.body.appendChild(ta);
            ta.select();
            document.execCommand('copy');
            document.body.removeChild(ta);
        });
        btnText.innerText = "Copied!";
        copySvg.style.display = "none";
        copiedSvg.style.display = "block";
        localStorage.setItem("Image-Info", JSON.stringify({"Prompt": prompt}));
        setTimeout(() => {
            const currentParams = new URLSearchParams(window.location.search);
            currentParams.set('prompt', 'true');
            window.location.href = `/pages/photo-to-canvas?mode=generate&${currentParams.toString()}`;
        }, 350);
      })
    })
  })

document.addEventListener("DOMContentLoaded", () => {
  const slider = document.querySelector(".igh-steps-container");

  if (window.innerWidth <= 768 && slider) {
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener("mousedown", (e) => {
      isDown = true;
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener("mouseleave", () => isDown = false);
    slider.addEventListener("mouseup", () => isDown = false);

    slider.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1.5;
      slider.scrollLeft = scrollLeft - walk;
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p2p-discover"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded" , () => {
    const copybtns = document.querySelectorAll(".dis-copy-btn");
    copybtns.forEach((btn) => {
      btn.addEventListener("click", () =>{
        const card = btn.closest(".dis-overlay-container");
        const prompt = card.querySelector(".dis-prompt").innerText;
        console.log(prompt);
        const btnText = btn.querySelector(".dis-copy-text")
        const copySvg = btn.querySelector(".dis-copy-svg")
        const copiedSvg = btn.querySelector(".dis-copied-svg")
        btnText.innerText = "Copied!";
        copySvg.style.display = "none";
        copiedSvg.style.display = "block";
        localStorage.setItem("Image-Info", JSON.stringify({"Prompt": prompt}));
       setTimeout(() => {
                const currentParams = new URLSearchParams(window.location.search);
                currentParams.set('prompt', 'true');
                window.location.href = `/pages/text-to-image?${currentParams.toString()}`;
            }, 350);
      })
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["p2p-hero"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const thumbs = document.querySelectorAll('.style-thumb');
  const mainImage = document.getElementById('main-image');

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', function () {
      thumbs.forEach((t) => t.classList.remove('active'));
      this.classList.add('active');
      const newImage = this.getAttribute('data-image');
      if (newImage) {
        mainImage.src = newImage;
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["steps-promt"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    function loadSlick(callback) {
      if (typeof jQuery === 'undefined') return;

      const slickCss = document.createElement('link');
      slickCss.rel = 'stylesheet';
      slickCss.href = 'https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css';
      document.head.appendChild(slickCss);

      const slickThemeCss = document.createElement('link');
      slickThemeCss.rel = 'stylesheet';
      slickThemeCss.href = 'https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick-theme.css';
      document.head.appendChild(slickThemeCss);

      const slickScript = document.createElement('script');
      slickScript.src = 'https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js';
      slickScript.onload = callback;
      document.body.appendChild(slickScript);
    }

    function initResponsiveSlick() {
      const $slider = jQuery('.step-promp__slider');

      if (window.innerWidth < 1350) {
        if (!$slider.hasClass('slick-initialized')) {
          $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            arrows: false,
            dots: true,
             centerMode: false,      // ✅ DISABLE CENTER
  variableWidth: true,    // keep card widths
  swipeToSlide: true,
responsive: [
  {
    breakpoint: 1024,
    settings: {
      centerMode: false,
      variableWidth: true,
    }
  },
  {
    breakpoint: 768,
    settings: {
      centerMode: false,
      variableWidth: true,
    }
  }
]

          });

          // Mobile arrow controls
document.querySelector(".prev-arrow")?.addEventListener("click", () => {
  $slider.slick("slickPrev");
});

document.querySelector(".next-arrow")?.addEventListener("click", () => {
  $slider.slick("slickNext");
});


          const styleTag = document.createElement('style');
          styleTag.innerHTML = `
            .step-promp__slider .slick-dots {
              display: flex ;
              justify-content: center;
              margin-top: 20px;
              padding: 0;
              list-style: none;
            }
            .step-promp__slider .slick-dots li button:before {
              background: #1F8FE5;
              content: '';
              border-radius: 50%;
              width: 12px;
              height: 12px;
              display: inline-block;
              opacity: 0.4;
            }
            .step-promp__slider .slick-dots li.slick-active button:before {
              opacity: 1;
              transform: scale(1.3);
            }
          `;
          document.head.appendChild(styleTag);
        }
      } else {
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('unslick');
        }
      }
    }

    loadSlick(initResponsiveSlick);
    window.addEventListener('resize', function () {
      setTimeout(initResponsiveSlick, 300);
    });
  });

  

  } catch(e) { console.error(e); }
})();
})();
